import { useUserContext } from '@vp/ubik-context';
import { useInVistaExperimentVariant } from '@99designs/experiments';
import {
    MainContent,
    ProductModelingMainContent,
    ProductOptionsQuery,
    ServiceDetailsPageDataQuery,
} from '@99designs/feature-service-details';
import { __, lowercaseLocaleToIso } from '@99designs/i18n';

interface ContentProps {
    serviceDetails: ServiceDetailsPageDataQuery['serviceDetailPage'];
    price: ServiceDetailsPageDataQuery['expertServices'][0]['price'];
    routeSpecifiedMpvId: string;
    serviceMpvId: string;
    printMpvId?: string;
    workId: string;
    isProductDesignLiveEnabled: boolean;
    productName: string;
    environment?: string;
    servicePrd: string;
    serviceVersion: number;
    expertServices: ServiceDetailsPageDataQuery['expertServices'];
    productOptions: ProductOptionsQuery['productOptions'];
}

export const Content = ({
    price,
    routeSpecifiedMpvId,
    workId,
    isProductDesignLiveEnabled,
    serviceDetails,
    serviceMpvId,
    productName,
    environment = 'production',
    servicePrd,
    serviceVersion,
    expertServices,
    printMpvId,
    productOptions,
}: ContentProps) => {
    const userContext = useUserContext();
    const useProductModelingLayout = useInVistaExperimentVariant(
        'design_services_sdp_product_modeling_poc'
    )('test');

    if (servicePrd === 'PRD-QTOI35I1R' && useProductModelingLayout && printMpvId) {
        return (
            <ProductModelingMainContent
                serviceMpvId={serviceMpvId}
                productName={productName}
                serviceDetails={serviceDetails}
                expertServices={expertServices}
                workId={workId}
                routeSpecifiedMpvId={routeSpecifiedMpvId}
                printMpvId={printMpvId}
                environment={environment}
                servicePrd={servicePrd}
                serviceVersion={serviceVersion}
                productOptions={productOptions}
            />
        );
    }

    return (
        <MainContent
            locale={lowercaseLocaleToIso(userContext.locale)}
            serviceMpvId={serviceMpvId}
            printMpvId={printMpvId}
            productName={productName}
            serviceDetails={serviceDetails}
            workId={workId}
            routeSpecifiedMpvId={routeSpecifiedMpvId}
            price={price}
            isProductDesignLiveEnabled={isProductDesignLiveEnabled}
            environment={environment}
            expertServices={expertServices}
        />
    );
};
